import { createMuiTheme, responsiveFontSizes } from '@material-ui/core/styles';

const theme = responsiveFontSizes(createMuiTheme({
  palette: {
    primary: {
      main: '#004990',
      light: '#4a8ecc',
      dark: '#19315b',
      contrastText: '#fff',
    },
    secondary: {
      main: '#7e488a',
      light: '#b075b2',
      dark: '#44274a',
      contrastText: '#fff',
    },
    contrastThreshold: 3,
    background: {
      default: '#f3f2f1',
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: ['"ff-scala-sans-pro"', 'Arial', 'sans-serif'].join(','),
    // htmlFontSize: 16,
    h1: {
      fontFamily: ['"ff-scala-sans-pro"', 'Arial', 'sans-serif'].join(','),
    },
    h2: {
      fontFamily: ['"ff-scala-sans-pro"', 'Arial', 'sans-serif'].join(','),
    },
    h3: {
      fontFamily: ['"ff-scala-sans-pro"', 'Arial', 'sans-serif'].join(','),
    },
    h4: {
      fontFamily: ['"ff-scala-sans-pro"', 'Arial', 'sans-serif'].join(','),
    },
    h5: {
      fontFamily: ['"ff-scala-sans-pro"', 'Arial', 'sans-serif'].join(','),
    },
    h6: {
      fontFamily: ['"ff-scala-sans-pro"', 'Arial', 'sans-serif'].join(','),
    },
    body1: {
      fontFamily: ['"ff-scala-sans-pro"', 'Arial', 'sans-serif'].join(','),
    },
    body2: {
      fontFamily: ['"ff-scala-sans-pro"', 'Arial', 'sans-serif'].join(','),
    },
    subtitle1: {
      fontFamily: ['"ff-scala-sans-pro"', 'Arial', 'sans-serif'].join(','),
    },
    subtitle2: {
      fontFamily: ['"ff-scala-sans-pro"', 'Arial', 'sans-serif'].join(','),
    },
  },
}));

export default theme;
// export default responsiveFontSizes(theme);
